import { EyeIcon, EyeSlashIcon } from '@phosphor-icons/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  TextInputFormField,
  TextInputFormFieldProps,
} from '@/components/form/text-input-form-field'

type PasswordInputFormFieldProps = Omit<TextInputFormFieldProps, 'type' | 'trailingAction'>

export const PasswordInputFormField = (props: PasswordInputFormFieldProps) => {
  const { t } = useTranslation(['common'])
  const [isVisible, setIsVisible] = useState(false)

  return (
    <TextInputFormField
      {...props}
      type={isVisible ? 'text' : 'password'}
      trailingAction={{
        icon: isVisible ? EyeSlashIcon : EyeIcon,
        label: isVisible ? t('common:actions.hidePassword') : t('common:actions.showPassword'),
        onClick: () => setIsVisible((visible) => !visible),
      }}
    />
  )
}
